module.exports = __webpack_public_path__ + "img/logo.ac5fa796.gif";